import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable()
export class SpinnerService {

  requests = 0;

  constructor(
    private spinner: NgxSpinnerService
  ) { }

  start() {
    if (this.requests === 0) {
      setTimeout(() => {
        if (this.requests > 0) {
          this.spinner.show();
        }
      }, 1000);
    }
    this.requests++;
  }

  finish() {
    this.requests--;
    if (this.requests === 0) {
      this.spinner.hide();
    }
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/spinner.service.ts